import React from 'react';
import type {
  InventorySupplierPaymentRecord,
  InventorySupplierRecord,
} from '@/renderer/types/inventory';

interface PaymentMethodOption {
  id: number;
  name: string;
}

export function SupplierPaymentsTable({
  payments,
  suppliers,
  paymentMethods,
}: {
  payments: InventorySupplierPaymentRecord[];
  suppliers: InventorySupplierRecord[];
  paymentMethods: PaymentMethodOption[];
}) {
  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white">
      <div className="max-h-[28rem] overflow-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 border-b border-gray-100 bg-gray-50">
            <tr className="text-left">
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                Date
              </th>
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                Supplier
              </th>
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                Method
              </th>
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                Reference
              </th>
              <th className="px-5 py-3 text-right text-xs font-semibold uppercase tracking-wide text-gray-500">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => {
              const supplier = suppliers.find(
                (s) => s.id === payment.supplier_id,
              );
              const pm = paymentMethods.find(
                (m) => m.id === payment.payment_method_id,
              );
              return (
                <tr key={payment.id} className="border-t border-gray-100">
                  <td className="px-5 py-4 text-gray-600">
                    {new Date(payment.payment_date).toLocaleDateString()}
                  </td>
                  <td className="px-5 py-4 font-medium text-gray-900">
                    {supplier?.name ?? 'Unknown supplier'}
                  </td>
                  <td className="px-5 py-4 text-gray-600">{pm?.name ?? '—'}</td>
                  <td className="px-5 py-4 text-gray-600">
                    {payment.reference ?? '—'}
                  </td>
                  <td className="px-5 py-4 text-right font-medium text-emerald-700">
                    {payment.amount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
